import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import ErrorBoundary from "./components/ErrorBoundary";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RegisterConfirmation from "./pages/RegisterConfirmation";
import ForgotPass from './pages/ForgotPass';

import StudentDashboard from "./pages/StudentDashboard";
import WriterDashboard from "./pages/WriterDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import OrderPreviewPage from "./pages/OrderPreviewPage";
import PaymentForm from "./pages/PaymentForm";
import WritersPage from './pages/WritersPage';
import OrderPage from './pages/OrderPage';
import MessagingCenter from './components/messaging/MessagingCenter';
import OrderPageWriting from "./pages/OrderPageWriting";
import AdminSamples from "./components/admin/AdminSamples";
import SamplesPage from './pages/SamplesPage';
import ManageWriters from './pages/managewriters'; // ADD THIS IMPORT

// Add these imports at the top
import BlogPage from './pages/BlogPage';
import AdminBlog from './pages/AdminBlog';
import BlogPostDetail from './pages/BlogPostDetail'; // You'll create this next

// Create Protected Route component ONLY for AdminSamples
const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Only allow users with ADMIN role
  if (user?.role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register-confirmation" element={<RegisterConfirmation />} />
            <Route path="/student-dashboard" element={<StudentDashboard />} />
            <Route path="/writer-dashboard" element={<WriterDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/order-preview" element={<OrderPreviewPage />} />
            <Route path="/payment" element={<PaymentForm />} />
            <Route path="/writers" element={<WritersPage />} />
            <Route path="/messages" element={<MessagingCenter />} />
            {/* ADD THE MANAGE WRITERS ROUTE HERE */}
            <Route path="/admin/manage-writers" element={
              <AdminProtectedRoute>
                <ManageWriters />
              </AdminProtectedRoute>
            } />
            
            {/* Writing Help Routes */}
            <Route path="/writing-help/essay" element={<OrderPageWriting />} />
            <Route path="/writing-help/research-paper" element={<OrderPageWriting />} />
            <Route path="/writing-help/thesis" element={<OrderPageWriting />} />
            <Route path="/writing-help/dissertation" element={<OrderPageWriting />} />
            <Route path="/writing-help/assignment" element={<OrderPageWriting />} />
            <Route path="/writing-help/book-report" element={<OrderPageWriting />} />
            <Route path="/writing-help/speech" element={<OrderPageWriting />} />
            <Route path="/writing-help/personal-statement" element={<OrderPageWriting />} />
            <Route path="/writing-help/literature-review" element={<OrderPageWriting />} />
            <Route path="/writing-help/coursework" element={<OrderPageWriting />} />
            <Route path="/writing-help/lab-report" element={<OrderPageWriting />} />
            <Route path="/writing-help/homework" element={<OrderPageWriting />} />
            <Route path="/writing-help/case-study" element={<OrderPageWriting />} />
            <Route path="/writing-help/capstone-project" element={<OrderPageWriting />} />
            <Route path="/writing-help/AI-humanizer" element={<OrderPageWriting />} />
            <Route path="/writing-help/proofreading" element={<OrderPageWriting />} />
            <Route path="/writing-help/Referencing" element={<OrderPageWriting />} />
            
            // Add these routes to your Routes component
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:postId" element={<BlogPostDetail />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
             // Add to your Routes
            <Route path="/samples" element={<SamplesPage />} />
            <Route path="/forgot-password" element={<ForgotPass />} />
            // In your src/App.js or routing file
            <Route path="/reset-password/:uid/:token/" element={<ForgotPass />} />
            
            {/* Admin Samples Route - PROTECTED FOR ADMINS ONLY */}
            <Route path="/dashboard/admin/samples" element={
              <AdminProtectedRoute>
                <AdminSamples />
              </AdminProtectedRoute>
            } />
          </Routes>
        </ErrorBoundary>
      </Router>
    </AuthProvider>
  );
}

export default App;
